// The action that gated the email-verification modal; selects the matching
// (fully translated) message, rather than interpolating a translated fragment.
export enum EmailVerificationAction {
  PURCHASE_SERVICE = 'purchase-service',
  START_CHAT = 'start-chat',
}
